import * as actionTypes from "./actionTypes";

export const getMailPosts = (page: number) => ({
  type: actionTypes.GET_MAIL_POSTS,
  page
});

export const sendMailPost = (recipient: string, content: string) => ({
  type: actionTypes.SEND_MAIL_POST,
  recipient,
  content
});

export const deleteMailPosts = (postIds: number[]) => ({
  type: actionTypes.DELETE_MAIL_POSTS,
  postIds
});
